import { Backdrop } from '@mui/material';
import { styled as muiStyled, css } from '@mui/material/styles';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import AddMembersForm from './members-form';
import Modal from '../base/modal';
import { ProjectData } from '../project-wizard/new-project-wizard-dialog';

interface Props {
  className?: string;
  onClose: () => void;
  open: boolean;
}

const MembersInvitePage: React.FC<Props> = ({ className, onClose, open }) => {
  const methods = useForm<ProjectData>();

  return (
    <Modal
      open={open}
      onClose={onClose}
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: 'rgba(186, 187, 191, 0.4)',
          },
        },
      }}
      style={{ width: '60%', marginLeft: '20%' }}
    >
      <FormProvider {...methods}>
        <form>
          <AddMembersForm onClose={onClose} />
        </form>
      </FormProvider>
    </Modal>
  );
};

export default muiStyled(MembersInvitePage)(({ theme }) => css``);
